import { EOfficeType, IJsonQuery } from '../json_query';
import { setTerms } from '../json_query/reducers/helpers';
import { getJsonQueryForSort } from '../utils/sort_request';

export const isNewobjectPage = (jsonQuery: IJsonQuery): boolean =>
  !!jsonQuery.geo && jsonQuery.geo.value.length === 1 && jsonQuery.geo.value[0].type === 'newobject';

export const isDeveloperPage = (jsonQuery: IJsonQuery): boolean =>
  !!jsonQuery.geo && jsonQuery.geo.value.length === 1 && jsonQuery.geo.value[0].type === 'builder';

export const isBSCenterPage = (jsonQuery: IJsonQuery): boolean =>
  !!jsonQuery.bs_center_id || (!!jsonQuery.bs_center && jsonQuery.bs_center.value.length === 1);

export const getBSCenterId = (jsonQuery: IJsonQuery): number | undefined => {
  let bsCenterId;

  if (jsonQuery.bs_center_id) {
    bsCenterId = jsonQuery.bs_center_id.value;
  }

  if (jsonQuery.bs_center && jsonQuery.bs_center.value.length === 1) {
    bsCenterId = jsonQuery.bs_center.value[0];
  }

  return bsCenterId;
};

export const getSortReplaceCoworkingOfficeType = (jsonQuery: IJsonQuery): IJsonQuery => {
  let jsonQueryForSort: IJsonQuery = getJsonQueryForSort(jsonQuery) || jsonQuery;
  if (
    jsonQueryForSort &&
    jsonQueryForSort.office_type &&
    jsonQueryForSort.office_type.value.length === 1 &&
    jsonQueryForSort.office_type.value[0] === EOfficeType.Coworking &&
    jsonQueryForSort.coworking_offer_type &&
    jsonQueryForSort.coworking_offer_type.value.length > 0
  ) {
    return setTerms('office_type')(jsonQueryForSort)([EOfficeType.Office]);
  }

  return jsonQueryForSort;
};
